import { useState, useEffect } from "react";

import { useGetLorasQuery } from "api/apiSlice";

import { AccessTime, CheckCircle, Image } from "@mui/icons-material";
import {
  Box,
  Divider,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

import BlurhashImage from "components/BlurhashImage";

import { useSelector } from "react-redux";
import zIndex from "@mui/material/styles/zIndex";
import AvatarCreator from "./AvatarCreator";
import SelectionMark from "components/SelectionMark";

import avatar from "../../assets/Union.png";

const AvatarSelector = ({ selectedLora, setselectedLora }) => {
  const theme = useTheme();
  const { data, error, isLoading } = useGetLorasQuery();

  const [loras, setloras] = useState([]);

  const { species, gender } = useSelector((state) => state.global);
  useEffect(() => {
    if (data?.data) {
      setloras(
        data.data.filter(
          (lora) => lora.gender === gender && lora.species === species
        )
      );
    }
  }, [data]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.toString()}</div>;

  return (
    <>
      {loras.length !== 0 && (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          padding="5px 0px 40px 0px"
        >
          <Typography sx={{ fontWeight: "700" }}>Choose avatar</Typography>
        </Box>
      )}

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 0.5, sm: 2, md: 3 }}
        useFlexGap
        sx={{
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loras.map((lora, index) => (
          <Paper
            elevation={6}
            sx={{
              position: "relative",
              transition: "transform 0.2s",
              "&:hover": {
                transform: "scale(1.03)",
                cursor: "pointer",
              },
              scale: lora.name === selectedLora ? 1.05 : 1,
              // boxShadow: "8px 8px 24px -9px rgba(66, 68, 90, 1)",
            }}
            onClick={() =>
              setselectedLora((current) =>
                current !== lora.name ? lora.name : ""
              )
            }
          >
            <BlurhashImage
              src={lora.image}
              blurhash={lora.blurhash}
              alt="sample"
              width="200px"
              height="200px"
              style={{
                borderRadius: "5px",
                objectFit: "cover",
                // border:
                //   lora.name === selectedLora
                //     ? `2px solid ${theme.palette.yellows[700]}`
                //     : "0px solid #fff",
              }}
            ></BlurhashImage>
            {lora.name === selectedLora && <SelectionMark />}
          </Paper>
        ))}
      </Stack>

      <>
        {loras.length !== 0 && (
          <Divider
            sx={{ padding: "30px 30px 30px 30px", marginBottom: "40px" }}
          />
        )}
        {loras.length === 0 && (
          <>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              padding="5px 0px 40px 0px"
            >
              <Typography sx={{ fontWeight: "700" }}>
                {loras.length !== 0
                  ? "Or create a new one"
                  : "Create your avatar"}
              </Typography>
            </Box>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 0.5, sm: 2, md: 3 }}
              useFlexGap
              sx={{ flexWrap: "wrap", justifyContent: "center" }}
            >
              <Avatar
                name="quick"
                time="5"
                photos="1"
                selected={selectedLora === "quick" ? true : false}
                handleCreateAvatar={() => setselectedLora("quick")}
              />
              <Avatar
                name="pro"
                time="20"
                photos="9"
                selected={selectedLora === "pro" ? true : false}
                handleCreateAvatar={() => setselectedLora("pro")}
              />
            </Stack>
          </>
        )}
      </>
    </>
  );
};

export default AvatarSelector;

const Avatar = ({ name, time, photos, selected, handleCreateAvatar }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={selected ? 9 : 6}
      sx={{
        position: name === "pro" ? "relative" : "relative",
        transition: "transform 0.2s",
        "&:hover": {
          transform: "scale(1.03)",
          cursor: "pointer",
        },

        width: "150px",
        height: "220px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        borderRadius: "10px",
        transform: selected ? "scale(1.03)" : "scale(1)",
      }}
      onClick={() => handleCreateAvatar(false)}
    >
      {name === "pro" && (
        <Paper
          elevation={3}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            bgcolor: theme.palette.yellows[700], // Use theme blue, or 'blue' for plain CSS
            color: "white",
            px: 1.5,
            py: 0.5,
            borderRadius: "0px 12px 0px 12px",
            fontWeight: "bold",
            fontSize: "12px",
            zIndex: 10,
            userSelect: "none",
          }}
        >
          PRO
        </Paper>
      )}
      {selected && <SelectionMark />}
      <img src={avatar} alt="avatar_icon" width="50px"></img>
      <Typography sx={{ fontWeight: "700" }}>{name} avatar</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <AccessTime fontSize="small" />
        <Typography sx={{ fontWeight: "500", fontSize: "12px" }}>
          {time} minutes
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <Image fontSize="small" />
        <Typography sx={{ fontWeight: "500", fontSize: "12px" }}>
          {photos === "1" ? `${photos} photo` : `${photos} photos`}
        </Typography>
      </Box>
    </Paper>
  );
};
